module.exports = __webpack_public_path__ + "img/layers (1).92ae272b.png";